// src/context/GeoContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { getBootstrappedCC } from "../utils/geo";

const GeoCtx = createContext({ cc: "" });

export const GeoProvider = ({ children }) => {
  const [cc, setCC] = useState(getBootstrappedCC());

  useEffect(() => {
    const handler = (e) => setCC(String(e?.detail?.cc || "").toUpperCase());
    if (typeof document !== "undefined") {
      document.addEventListener("df:cc", handler);
      return () => document.removeEventListener("df:cc", handler);
    }
  }, []);

  return <GeoCtx.Provider value={{ cc }}>{children}</GeoCtx.Provider>;
};

export const useGeo = () => useContext(GeoCtx);
